import { useBrandSpecialQualifyingStatus } from '@iheartjane/data-access/react-query';
import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { SpecialCallout, getSpecialApplicableWeights } from '@iheartjane/menu';

import { useCurrentStoreId } from '@jane/shared-ecomm/hooks';
import { brandSpecialOrProductHasSegments } from '@jane/shared/util';

import { BrandSpecialCallout } from '../../brandSpecialCallout/brandSpecialCallout';
import type { JaneGoldMenuPdpCalloutProps } from '../janeGoldCallout.types';

export const JaneGoldMenuPdpCallout = ({
  brandSpecial,
  cartBrandDiscounts,
  cartUuid,
  inStockWeights,
  isGuestUser,
  onBrandSpecialClick,
}: JaneGoldMenuPdpCalloutProps) => {
  const specialsRedesignMenu = useFlag(FLAGS.c3SpecialsRedesignMenu);
  const storeId = useCurrentStoreId();
  const isBundle = brandSpecial.special_type !== 'product';
  const { data: status } = useBrandSpecialQualifyingStatus(
    {
      cartUuid: cartUuid,
      specialId: brandSpecial.id,
      storeId: storeId,
    },
    { enabled: isBundle }
  );

  const isQualified =
    (isBundle && status?.qualifying_status === 'qualified') || !isBundle;
  const isApplied = cartBrandDiscounts?.some(
    (discount) => discount.brand_special_id === brandSpecial.id
  );

  return specialsRedesignMenu ? (
    <SpecialCallout
      applicableWeights={getSpecialApplicableWeights({
        applicableWeights: brandSpecial.applicable_weights,
        inStockWeights: inStockWeights ?? [],
      })}
      brandImage={brandSpecial.product_brand.logo_url ?? null}
      brandName={brandSpecial.product_brand.name}
      isApplied={Boolean(isApplied)}
      isAuthenticated={!isGuestUser}
      isGold
      isQualified={isQualified}
      onClick={() => onBrandSpecialClick && onBrandSpecialClick(brandSpecial)}
      segmented={brandSpecialOrProductHasSegments({
        brandSpecial: brandSpecial,
      })}
      specialTitle={brandSpecial.title}
      specialType={
        brandSpecial.special_type === 'product' ? 'product' : 'bundle'
      }
      variant="pdp"
    />
  ) : (
    <BrandSpecialCallout
      brandImage={brandSpecial.product_brand.logo_url ?? null}
      brandName={brandSpecial.product_brand.name}
      isApplied={Boolean(isApplied)}
      isAuthenticated={!isGuestUser}
      isQualified={isQualified}
      onClick={() => onBrandSpecialClick && onBrandSpecialClick(brandSpecial)}
      segmented={brandSpecialOrProductHasSegments({
        brandSpecial: brandSpecial,
      })}
      specialTitle={brandSpecial.title}
      specialType={
        brandSpecial.special_type === 'product' ? 'product' : 'bundle'
      }
      variant="pdp"
    />
  );
};
